import { useCallback } from 'react'
import { API_HOST_NAME } from '../../constants.js'
import { useAuthentication } from '../../../../../../contexts/AuthenticationContext.jsx'
import fetchJSON from '../../../../fetchJSON.js'

const useComposeResource = (teamId, projectId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/projects/${projectId}/compose`
  const { getValidToken } = useAuthentication()

  const getAuthenticatedOptions = useCallback((accessToken) => {
    return {
      headers: {
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    }
  }, [])

  const get = useCallback(() => {
    return getValidToken()
      .then((accessToken) => fetchJSON(url, 'GET', getAuthenticatedOptions(accessToken)))
  }, [url, getValidToken, getAuthenticatedOptions])

  const update = useCallback((data) => {
    return getValidToken()
      .then((accessToken) => fetchJSON(url, 'PUT', getAuthenticatedOptions(accessToken), data))
  }, [url, getValidToken, getAuthenticatedOptions])

  return { get, update }
}

export default useComposeResource
